<template>
  <div class="mt-10 video-preview">
    <img v-show="image.visible" alt="Video thumbnail preview" class="w-full cursor-pointer" :src="`https://content.jwplatform.com/thumbs/${this.mediaId}.jpg`" @click="active=true" @load="imageLoaded" @error="imageError"/>

    <div class="flex" v-if="image.error">
      <feather-icon
        icon="XIcon"
        svgClasses="h-7 w-7 color-current text-danger"
        class="pl-2 mr-4 -mt-1"
      /> <strong>Video not found</strong>
    </div>
    
    <div
      class="lds-ring pl-8 mr-4"
      v-if="image.loading"
    >
      <div></div><div></div><div></div><div></div>
    </div>

    <vs-popup v-if="active" class="video-preview-wrapper" classContent="video-preview-popup"  title="Video preview" :active.sync="active">
      <iframe :src="getURL" width="100%" height="100%" frameborder="0" title="Ine-ccie-designing-sd-access-solution-trailer" :class="`iframe-preview`" allowfullscreen></iframe>
    </vs-popup>
  </div>
</template>
<script>

export default {
  name: 'VideoPreview',
  props: {
    mediaId: String
  },
  data() {
    return {
      active: false,
      image: {
        visible: false,
        loading: false,
        error: false
      }
    }
  },
  computed: {
    getURL() {
      return this.mediaId ? `https://cdn.jwplayer.com/players/${this.mediaId}.html` : ''
    }
  },
  methods: {
    imageLoaded() {
      this.image.visible = true
      this.image.loading = this.image.error = false
    },
    imageError() {
      this.image.error = true
      this.image.loading = this.image.visible = false
    }
  },
  watch: {
    'mediaId': function() {
      this.image.loading = true
      this.image.error = this.image.visible = false
    }
  }
}
</script>
<style lang="scss">
  .video-preview-wrapper .vs-popup {
    width: 650px;
  }
  .video-preview-popup {
    width: 640px;
    height: 400px;
  }
</style>